import { Box, Dialog, DialogContent, DialogProps } from '@mui/material'
import { FormProvider } from 'react-hook-form'
import { useDispatch } from 'react-redux'

import ActionButtons from 'components/action-buttons/action-buttons.component'
import DropAddressForm from 'components/forms/drop-address-form/drop-address-form.component'
import { useDropAddressForm } from 'components/forms/drop-address-form/drop-address-form.hooks'
import { EditModeProvider } from 'contexts/edit-mode.context'
import { addHookTrailerTask } from 'store/trips/trips.slice'
import {
  buildDropAddress,
  DropAddressFormData,
} from 'components/drop-form-dialog/drop-form-dialog.utils'

type HookFormDialogProps = {
  orderId: number | null
  userOrderId: string
  deliveryOrderEventId: number | null
  handleClose: () => void
} & DialogProps

const HookFormDialog = ({
  open,
  orderId,
  userOrderId,
  deliveryOrderEventId,
  handleClose,
}: HookFormDialogProps) => {
  const dispatch = useDispatch()
  const { formMethods } = useDropAddressForm()

  const handleSave = (data: DropAddressFormData) => {
    if (orderId == null || !userOrderId || deliveryOrderEventId == null) return

    const address = buildDropAddress(data)

    dispatch(
      addHookTrailerTask({
        address,
        orderId: userOrderId,
        sourceOrderPkId: orderId,
        deliveryOrderEventId,
      })
    )
    formMethods.reset()
    handleClose()
  }

  const handleDialogClose = () => {
    formMethods.reset()
    handleClose()
  }

  return (
    <Dialog open={open} onClose={handleDialogClose} maxWidth="sm">
      <DialogContent sx={{ p: 0 }}>
        <FormProvider {...formMethods}>
          <form onSubmit={formMethods.handleSubmit(handleSave)}>
            <Box p={3}>
              <EditModeProvider initialEditMode suppressAutofill>
                <DropAddressForm />
              </EditModeProvider>
            </Box>
            <Box mt={2}>
              <ActionButtons
                firstBtnProps={{
                  title: 'Cancel',
                  onClick: handleDialogClose,
                  bgcolor: 'secondary.main',
                }}
                secondBtnProps={{
                  title: 'Save',
                  onClick: formMethods.handleSubmit(handleSave),
                }}
              />
            </Box>
          </form>
        </FormProvider>
      </DialogContent>
    </Dialog>
  )
}

export default HookFormDialog
